import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ModalDismissReasons, NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { FilterProjectInfoGroupDto } from 'src/app/web/interfaces/project/list/filterProjectInfoGroupDto';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { FormBuilder, FormGroup } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiServiceProject } from '../../../apis/ApiServiceProject';
import { formatDate } from '@angular/common';
import { ErrorService } from 'src/app/shared/services/errors.service';



@Component({
  selector: 'app-delete-popup-project',
  templateUrl: './delete-popup-project.component.html',
  styleUrls: ['./delete-popup-project.component.scss']
})
export class DeletePopupProjectComponent implements OnInit {


  closeResult = '';
  idProject: number;
  lisProject: any[] = [];
  closeCheck : any[] = [];
  listStage : any[] = [];
  listSprint: any[] = [];
  listAssignment: any[] = [];
  listRisk: any[] = [];
  listMilestone: any[] = [];
  listPayment: any[] = [];
  fecha ='';
  projectName: string;
  

  

  @ViewChild('defaultTabButtons')
  public defaultTabButtonsTpl: TemplateRef<any>;
  
  constructor(config: NgbModalConfig, 
              private modalService: NgbModal,  
              private apiService: ApiServiceProject,
              private http: HttpClient,
              private router: Router,
              private route: ActivatedRoute,
              private spinner: NgxSpinnerService,
              private fb: FormBuilder,
              private errorService:ErrorService) {

    config.backdrop = 'static';
    config.keyboard = false;
   }


  ngOnInit(): void {
    
    

  }

  public open(id:number) {

    this.spinner.show();

    this.idProject = id;

    let rs = JSON.parse(localStorage.getItem("info-mtn"));
    this.lisProject = rs.filter( n =>  n.id == this.idProject);

    this.projectName =  this.lisProject['projectAlias']

    this.apiService.getService('project-info?id_project='+id)
    .subscribe({
      next: (rs: any) => {
        if (rs) {
         this.spinner.hide();
         this.lisProject = rs;
         this.projectName = rs['title'];
        } else {
          this.spinner.hide();
          Swal.fire({
          title:  rs.error,
          text: '',
          icon: 'error',
          heightAuto: false
          });
        }
      },
      error: (error) => {
       //  this.spinner.hide();
        this.errorService.error(error);
      },
    });


    this.apiService.getService('project-delete-check?id_project='+id)
    .subscribe({
      next: (rs: any) => {
        if (rs) {
          this.spinner.hide();
          this.closeCheck = rs;
          this.listStage = rs['listStage'];
          this.listSprint = rs['listSprint'];
          this.listAssignment = rs['listAssignment'];
          this.listRisk = rs['listRisk'];
          this.listMilestone = rs['listMilestone'];
          this.listPayment = rs['listPayment'];
          
        } else {
          this.spinner.hide();
          Swal.fire({
          title:  rs.error,
          text: '',
          icon: 'error',
          heightAuto: false
          });
        }
      },
      error: (error) => {
       //  this.spinner.hide();
        this.errorService.error(error);
      },
    });
    

    this.modalService.open(this.defaultTabButtonsTpl, { ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });

  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

   deleteProject(){

      Swal.fire({
        title: `¿Esta seguro de eliminar el proyecto ${this.projectName}?`,
        text: 'si está seguro de esta accion, presione el boton Aceptar',
        icon: 'warning',
        showCancelButton:true,
        confirmButtonText:'Aceptar',
        cancelButtonColor:"No, cancelar",
        heightAuto: false
      }).then((res) =>{
        if (res.isConfirmed) {
        this.spinner.show()
        this.apiService.deleteService('project-delete?id_project='+this.idProject ).subscribe({
          next: (rs: any) =>{
            if (rs) {
              this.spinner.hide();
              Swal.fire({title:'Exito!',text:'Se ha eliminado con exito',icon: 'success',heightAuto: false}).then(()=>{location.reload()})
            }else{
              this.spinner.hide();
              Swal.fire({title:rs.error ,text: '',icon: 'error',heightAuto: false});
            }
          },error: (error) =>{
            this.errorService.error(error);
          }});
  
      }else if ( res.dismiss === Swal.DismissReason.cancel){
        Swal.fire({
          title: 'Cancelado',
          text: 'Operación cancelada.',
          icon: 'error',
          heightAuto: false
          })
        }
    });


}
}


